module.exports = __webpack_public_path__ + "img/20201112-3.c95b31b8.jpg";